import axios from "axios";
import { useEffect } from "react";
import { useQuery } from "react-query";
import useSignup from "../../common/hooks/pages/useSignup";
import { usePopup } from "../../common/contexts/PopupContext";
import { setLocalStorage } from "../../common/helpers/browserStorage";
import { useAuth } from "../../common/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function GoogleCallback() {
  const { googleCallback } = useSignup();

  const { setAccessToken } = useAuth();
  const { toast } = usePopup();

  const navigate = useNavigate();

  const { isLoading, error, isError } = useQuery({
    retry: false,
    queryKey: "googleCallback",
    queryFn: googleCallback,
    onSuccess: (res) => {
      const { message, accessToken } = res?.data || {};

      setLocalStorage("accessToken", accessToken);
      setAccessToken(accessToken);

      navigate("/organization");

      toast(message, "success");
    },
  });

  return (
    <div className="text-xl  text-gray-500">
      {isError ? (
        <div className="text-red-600">
          {error?.response?.data?.message ||
            "Something went wrong while signing in with google"}
        </div>
      ) : null}

      {isLoading ? "Signing in with google... please wait" : null}
    </div>
  );
}

export default GoogleCallback;
